import { Injectable } from "@angular/core";
import { AccountIdentity } from "@common/domain";
import { select, Store } from "@ngrx/store";
import { AccountEntity } from "@youm-front/account/domain";
import { AccountJwtService } from "@youm-front/account-jwt/data-access";
import { map } from "rxjs/operators";
import { AccountActions } from "../actions";
import { AccountSelectors } from "../selectors";

@Injectable()
export class AccountFacade {
  account$ = this.store.pipe(select(AccountSelectors.account));
  isLoading$ = this.store.pipe(select(AccountSelectors.isLoading));
  conf2SignInFailure$ = this.store.pipe(
    select(AccountSelectors.conf2SignInFailure)
  );

  constructor(
    private readonly store: Store,
    private readonly accountJwtService: AccountJwtService
  ) {}

  get authorized$() {
    return this.accountJwtService.accountJwt$.pipe(map((_) => !!_));
  }

  get defaultRoomPid$() {
    return this.account$.pipe(map((_) => _?.value.defaultRoom.pid));
  }

  get accountEntity$() {
    return this.account$.pipe(
      map((_) => (_ instanceof AccountEntity ? _ : null))
    );
  }

  guestAccountSignIn(identity: AccountIdentity) {
    return this.store.dispatch(AccountActions.guestAccountSignIn({ identity }));
  }

  redirectToAuth() {
    return this.store.dispatch(AccountActions.redirectToAuth());
  }

  signOut() {
    return this.store.dispatch(AccountActions.signOut());
  }
}
